<template>
  <div v-if="isOpen">
    <PmwParagraph size="paragraph-80" weight="light" class="allotment--title">
      Disponibilidade
    </PmwParagraph>

    <PmwButton
      v-show="!showInput"
      layout="outline"
      variation="blue-100"
      hasIcon
      class="allotment--button"
      @click="showInput = true"
    >
      Adicionar disponibilidade
    </PmwButton>

    <AllotmentEditionTable
      v-if="showInput"
      :allotmentRooms="allotmentRooms"
      :hotelRoomsData="allHotelRooms"
    />
  </div>
</template>

<script>
import AllotmentEditionTable from '@/components/hotel/rateFluctuations/restrictionsSettings/AllotmentEditionTable'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'

export default {
  name: 'AllotmentForm',

  components: {
    AllotmentEditionTable,
    PmwButton,
    PmwParagraph
  },

  props: {
    value: {
      type: Object,
      default: () => {}
    },

    allHotelRooms: {
      type: Array,
      default: () => []
    },

    isOpen: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showInput: false,

      allotmentRooms: []
    }
  },

  computed: {
    /** Array com os quartos ativos selecionados na tarifa */
    activeRooms() {
      const arr = []
      this.value.quartos.forEach((item) => {
        arr.push(...this.allHotelRooms.filter((a) => a.codigo === item))
      })

      return arr
    }
  },

  watch: {
    allotmentRooms(newVal) {
      if (newVal) {
        this.value.allotmentQuartos = newVal
      }
    },

    activeRooms: {
      handler(newVal) {
        if (newVal && newVal.length) {
          this.allotmentRooms = []

          newVal.forEach((item) => {
            this.allotmentRooms.push({
              allotment: null,
              allotmentExclusivoTarifa: false,
              codigoQuarto: item.codigo
            })
          })
        } else {
          this.allotmentRooms = []

          this.allHotelRooms.forEach((item) => {
            this.allotmentRooms.push({
              allotment: null,
              allotmentExclusivoTarifa: false,
              codigoQuarto: item.codigo
            })
          })
        }

        this.setValues()
      }
    },

    'value.allotmentQuartos': {
      handler(newVal) {
        if (newVal) {
          if (newVal.some((item) => item.allotment !== null)) {
            this.showInput = true
          }
        }
      }
    }
  },

  methods: {
    /** Passa os valores, caso já estejam salvos, para o componente */
    setValues() {
      if (this.value.allotmentQuartos) {
        this.value.allotmentQuartos.forEach((item) => {
          let idx = -1
          idx = this.allotmentRooms.findIndex(
            (el) => el.codigoQuarto === item.codigoQuarto
          )

          if (idx > -1) {
            this.allotmentRooms[idx].allotment = item.allotment
            this.allotmentRooms[idx].allotmentExclusivoTarifa =
              item.allotmentExclusivoTarifa
          }
        })
      } else {
        return
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.allotment {
  &--title {
    margin: 25px 0 35px;
  }

  &--button {
    width: 175px;
  }

  &-row {
    display: flex;
    gap: 20px;
    align-items: center;

    &--name {
      width: 150px;
    }

    &--input {
      width: 100px;
    }

    &--checkbox {
      width: 200px;
    }
  }
}
</style>
